export default __webpack_public_path__ + "static/media/ra-video.d48340ae.mp4";